import React, { useEffect } from "react";
import "../css/pages/singleContentShow.scss";
import Sidebar from "./components/Sidebar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useNavigate, useParams } from "react-router-dom";
import Comment from "./components/Comment";
import SingleContentSlider from "./components/singleContentSlider";
import { LoadingIndicator } from "./components/loadingIndicator";
import { useGetGalleryById, useGetPostById } from "../queries";
import { iImageContent } from "./components/ContentShow";
import PreviousComments from "./components/PreviousComments";
interface Props {
  category: "posts" | "gallery";
}

const SingleContentShow: React.FC<Props> = ({ category }) => {
  const { id } = useParams();
  const contentId = Number(id);
  const history = useNavigate();

  // Call both hooks unconditionally
  const postItem = useGetPostById(contentId, { enabled: category === "posts" });
  const galleryItem = useGetGalleryById(contentId, {
    enabled: category !== "posts",
  });
  useEffect(() => {
    // Redirect to 404 if contentId is not a number
    if (isNaN(contentId)) {
      history("/404");
    }
  }, [contentId, history]);

  const isPost = category === "posts";
  const content = isPost ? postItem.data : galleryItem.data;
  const contentLoading = isPost ? postItem.isLoading : galleryItem.isLoading;
  const contentImages: iImageContent[] = isPost
    ? content?.PostMedia || []
    : content?.GalleryMedia || [];
  if (contentLoading) {
    return (
      <div className="singleContentShowPage">
        <div className="midSection">
          <LoadingIndicator fullPageHeight={true} />
        </div>
      </div>
    );
  }

  const renderImageBlock = () => {
    if (contentImages?.length > 1) {
      return <SingleContentSlider mediaList={contentImages} />;
    } else if (contentImages?.length === 1) {
      return (
        <img src={require(`../${contentImages[0].path}`)} alt="content pic" />
      );
    }
    return null;
  };

  return (
    <div className="singleContentShowPage">
      <div className="midSection">
        <div className="contentAndSide">
          <div className="contentPanelContainer">
            <div className="contentCommentContainer">
              <div className="contentPanel">
                <div className="contentTitleMain">{content?.title}</div>
                <div className="contentImageContainerMain">
                  {renderImageBlock()}
                </div>
                <div className="contentContainerMain">
                  <div
                    className="contentTextMain"
                    dangerouslySetInnerHTML={{ __html: content?.postText }}
                  />
                </div>
                <div className="contentDateContainerMain">
                  <div className="ContentAuthorName">
                    <AccountCircleIcon fontSize="small" />
                    <div>ادمین</div>
                  </div>
                  <div className="contentDateIconContainer">
                    <div className="dateIconContentMain">
                      <AccessTimeIcon fontSize="small" />
                    </div>
                    <div className="contentDateMain">{content?.date}</div>
                  </div>
                </div>
              </div>
              <Comment category={category} contentId={contentId} />
              <PreviousComments category={category} contentId={contentId} />
            </div>
          </div>

          <Sidebar category="gallery" />
        </div>
      </div>
    </div>
  );
};

export default SingleContentShow;
